var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStandart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.28035 6.28035 0 14 0C21.7197 0 28 6.28035 28 14C28 21.7197 21.7197 28 14 28C6.28035 28 0 21.7197 0 14Z",
    fill: "url(#linear-768456)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 16.9578C8.84931 19.4403 10.8626 21 13.9684 21C17.2367 21 19.25 19.3573 19.25 16.6717C19.25 14.6045 18.1215 13.4509 15.5032 12.8879L13.9323 12.5465C12.4065 12.2142 11.7835 11.7436 11.7835 10.9222C11.7835 9.90705 12.6864 9.26104 14.0497 9.26104C15.3678 9.26104 16.3248 9.96243 16.4512 11.0145H19.0153C18.934 8.64272 16.9026 7 14.0316 7C11.0252 7 9.04794 8.65194 9.04794 11.1622C9.04794 13.1925 10.2126 14.4568 12.5871 14.9644L14.2844 15.3336C15.8824 15.6842 16.5325 16.1734 16.5325 17.0224C16.5325 18.0283 15.5303 18.7297 14.1129 18.7297C12.578 18.7297 11.5127 18.0376 11.3863 16.9578H8.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-768456",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16CF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C7B39"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStandart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/standart.dda3d06c.svg";